import { Routes } from '@angular/router';
import { AccueilComponent } from './accueil/accueil.component';
import { PowerbiTemplateComponent } from './shared/components/powerbi-template/powerbi-template.component';
import { PilotTradeComponent } from './pilot-trade/pilot-trade.component';
import { GenericManufacturerSimulationComponent } from './generic-manufacturer-simulation/generic-manufacturer-simulation.component';
import { GestionComptesComponent } from './gestion-comptes/gestion-comptes.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { NotFoundComponent } from '@hygie31/ngx-hygie31-kit-ui-17';
import { HelpComponent } from './shared/components/help/help.component';
import { AuthGuard } from 'src/app/auth.guard';
import { PromotionsDetailComponent } from './promotions/components/promotions-detail/promotions-detail.component';
import { WholesalerSimulationComponent } from './wholesaler-simulation/wholesaler-simulation.component';
import { LegalMentionComponent } from './legal-mention/legal-mention.component';
import { GestionAutorisationsComponent } from './gestion-autorisations/gestion-autorisations.component';
import { GESTION_AUTORISATIONS_ROUTES } from './gestion-autorisations/gestion-autorisations.routes';
import { RedirectGestacComponent } from './shared/components/redirect-gestac/redirect-gestac.component';

export const routes: Routes = [
  { path: '', component: AccueilComponent, canActivate: [AuthGuard] },
  {
    path: 'cockpit',
    component: PowerbiTemplateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cockpit/optique',
    component: PowerbiTemplateComponent,
    data: { type: 'cockpit-optique' },
    canActivate: [AuthGuard],
  },
  {
    path: 'rentabilitelineaire',
    component: PowerbiTemplateComponent,
    data: { type: 'Pilotage_rentabilite' },
    canActivate: [AuthGuard],
  },
  {
    path: 'marge',
    component: PowerbiTemplateComponent,
    data: { type: 'Pilotage_marge' },
    canActivate: [AuthGuard],
  },
  {
    path: 'ventes',
    component: PowerbiTemplateComponent,
    data: { type: 'Pilotage_ventes' },
    canActivate: [AuthGuard],
  },
  {
    path: 'stock',
    component: PowerbiTemplateComponent,
    data: { type: 'Pilotage_stock' },
    canActivate: [AuthGuard],
  },
  {
    path: 'ranking',
    component: PowerbiTemplateComponent,
    data: { type: 'Ranking' },
    canActivate: [AuthGuard],
  },
  {
    path: 'pilotagefideliteofficine',
    component: PowerbiTemplateComponent,
    data: { type: 'Fidelite-officine' },
    canActivate: [AuthGuard],
  },
  {
    path: 'pilotagefideliteclient',
    component: PowerbiTemplateComponent,
    data: { type: 'Fidelite-client' },
    canActivate: [AuthGuard],
  },
  {
    path: 'pilotagepricing',
    component: PowerbiTemplateComponent,
    data: { type: 'Pricing' },
    canActivate: [AuthGuard],
  },
  {
    path: 'suivilabo',
    component: PowerbiTemplateComponent,
    data: { type: 'Suivi_labo' },
    canActivate: [AuthGuard],
  },
  {
    path: 'operateurs',
    component: PowerbiTemplateComponent,
    data: { type: 'Pilotage_operateur' },
    canActivate: [AuthGuard],
  },
  { path: 'trade', component: PilotTradeComponent, canActivate: [AuthGuard] },
  {
    path: 'simulation-generique',
    component: GenericManufacturerSimulationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'simulation-grossiste',
    component: WholesalerSimulationComponent,
    canActivate: [AuthGuard],
  },
  { path: 'promotions', component: PromotionsComponent, canActivate: [AuthGuard] },
  { path: 'promotion/details', component: PromotionsDetailComponent, canActivate: [AuthGuard] },
  { path: 'gestioncomptes', component: GestionComptesComponent, canActivate: [AuthGuard] },
  {
    path: 'gestionautorisations',
    children: GESTION_AUTORISATIONS_ROUTES,
    canActivate: [AuthGuard],
  },
  { path: 'aide', component: HelpComponent, canActivate: [AuthGuard] },
  { path: 'not-found', component: NotFoundComponent },
  { path: 'forbidden', component: NotFoundComponent },
  {
    path: 'mex',
    component: PowerbiTemplateComponent,
    data: { type: 'Mex' },
    canActivate: [AuthGuard],
  },
  {
    path: 'pilotageservicedesante',
    component: PowerbiTemplateComponent,
    data: { type: 'Servicedesante' },
    canActivate: [AuthGuard],
  },
  {
    path: 'biosimilaires',
    component: PowerbiTemplateComponent,
    data: { type: 'Biosimilaires' },
    canActivate: [AuthGuard],
  },
  {
    path: 'generiques',
    component: PowerbiTemplateComponent,
    data: { type: 'Generiques' },
    canActivate: [AuthGuard],
  },
  {
    path: 'pilotageaccordscommerciaux',
    component: RedirectGestacComponent,
    canActivate: [AuthGuard],
  },
  { path: 'mention-legales', component: LegalMentionComponent },
];
